<template>
  <div class="flex items-start gap-2">
    <div
      class="z-10 flex h-7 w-7 items-center justify-center rounded-full bg-green-400"
    >
      <span class="text-center text-xs no-localize-translate">
        {{ authorInitials }}
      </span>
    </div>
    <div class="flex w-full flex-col gap-2">
      <div class="flex justify-between">
        <div class="no-localize-translate flex items-center gap-2">
          <span class="text-xs text-slate-600 no-localize-translate">{{ comment.authorName }}</span>
          <span class="text-xs text-slate-600"> • </span>
          <span class="text-xs text-slate-400"> {{ comment.createdAt }} </span>
        </div>

        <div class="flex items-center gap-2">
          <div
            v-if="comment.mainComment"
            class="flex items-center gap-2"
          >
            <ToggleInput
              :condition="comment.resolved"
              screen-reader-text="Resolve this comment"
              size="sm"
              @condition-changed="resolveToggleChanged"
            />
            <span
              v-tooltip="comment.resolved ? comment.resolvedAt : ''"
              class="text-xs text-slate-700"
            >
              {{ comment.resolved ? "Resolved" : "Resolve" }}
            </span>
          </div>
          <div
            v-if="comment.updatedAt"
            class="flex items-center"
          >
            <span
              v-tooltip="comment.updatedAt"
              class="text-xs text-gray-300"
            >Edited</span>
          </div>
          <icon-menu v-if="isAuthor && !comment.resolved">
            <template #icon>
              <dots-horizontal custom-style="w-4 h-4 stroke-slate-500" />
            </template>
            <template #menu-items>
              <div class="flex flex-col p-0">
                <button
                  class="m-0 p-2 text-start text-xs hover:bg-slate-100"
                  @click="editButtonClick"
                >
                  Edit
                </button>
                <button
                  class="m-0 p-2 text-xs text-red-500 hover:bg-slate-100"
                  @click="deleteButtonClick"
                >
                  Delete
                </button>
              </div>
            </template>
          </icon-menu>
        </div>
      </div>
      <div>
        <tip-tap-richtext-display :value="comment.content" />
      </div>
      <div class="flex">
        <button
          class="text-xs"
          :class="{
            'text-green-700 hover:underline': !comment.resolved,
            'cursor-default text-gray-400': comment.resolved,
          }"
          :disabled="comment.resolved"
          @click.stop="replyButtonClicked"
        >
          Reply
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AmoqComment',

  props: {
    comment: {
      type: Object,
      default: () => {
        return {
          authorId: null,
          authorName: '',
          createdAt: '',
          updatedAt: '',
          content: '',
          mainComment: false,
          resolved: false,
          resolvedAt: '',
        }
      },
    },
    isAuthor: {
      type: Boolean,
      default: false,
    },
  },

  emits: [
    'edit-button-clicked',
    'delete-button-clicked',
    'reply-button-clicked',
    'resolve-toggle-changed',
  ],

  computed: {
    authorInitials() {
      return getInitialsFromName(this.comment.authorName)
    },
  },

  methods: {
    editButtonClick() {
      this.$emit('edit-button-clicked')
    },
    deleteButtonClick() {
      this.$emit('delete-button-clicked')
    },
    replyButtonClicked() {
      this.$emit('reply-button-clicked')
    },
    resolveToggleChanged(val) {
      this.$emit('resolve-toggle-changed', val)
    },
  },
}
</script>
